import { StatesMap } from "@brz-shared/states.map";
import { getAge } from "./get.age";

type FieldSettings<D> = {
    dob?: {
        minAge: number;
        maxAge: number;
    },
    age?: {
        minAge: number;
        maxAge: number;
    },
    onValidateField?: (fieldname: keyof D) => boolean;
};

export function useFieldValidator<D>(data: D, settings?: FieldSettings<D>) {


    function validateField(field: keyof D, returnBoolean: boolean = true): boolean | number {

        if ( typeof settings?.onValidateField === 'function' ) {
            return settings?.onValidateField(field);
        }

        switch (field) {
            case 'income':
                let incomeStr = <unknown>data[field];

                if ( typeof incomeStr !== 'string' ) {
                    return returnBoolean ? false : -1;
                }

                let income = parseInt((incomeStr as string).replace(/[^\d]/g, ''), 10);

                if ( income > 0 ) {
                    return returnBoolean ? true : 1;
                } else if ( income <= 0 ) {
                    return returnBoolean ? false : 0;
                } else {
                    return returnBoolean ? false : -1;
                }
            case 'age':
                let _age = parseInt(<string>data[field]);

                if ( isNaN(_age) ) {
                    return returnBoolean ? false : 0;
                }
                

                // If younger the "min age"
                if ( settings?.age?.minAge && _age < settings.age.minAge ) {
                    return returnBoolean ? false : -1;
                }
                
                // If older then "max age"
                if ( settings?.age?.minAge && _age > settings.age.maxAge ) {
                    return returnBoolean ? false : -2;
                }

                return returnBoolean ? true : 1;
            case 'dob':
                let dob = <string>data[field];

                // Check if incorrect format
                if( !/\d{2}\/\d{2}\/[1-9]\d{3}/.test(dob as string) ) {
                    return returnBoolean ? false : 0;
                }

                const age = getAge(dob);

                if ( !age ) {
                    return returnBoolean ? false : 0;
                }

                if ( !settings?.dob?.minAge || !settings?.dob?.maxAge ) {
                    return returnBoolean ? true : 1;
                }

                // If younger the "min age"
                if ( age < settings.dob.minAge ) {
                    return returnBoolean ? false : -1;
                }
                
                // If older then "max age"
                if ( age > settings.dob.maxAge ) {
                    return returnBoolean ? false : -2;
                }

                return returnBoolean ? true : 1;
            case 'attendingDate':
                let date = <unknown>data[field];

                // Check if incorrect format
                if (!/\d{2}\/\d{2}\/[1-9]\d{3}/.test(date as string)) {
                    return returnBoolean ? false : 0;
                }

                return returnBoolean ? true : 1;
            case 'works':
                let works = <unknown>data[field];
                return <number | boolean>works;
            // case 'email':
            //     let email = formData[field];
            //     return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
            // Handle booleans and empty strings
            case 'phone':
                let phone = <unknown>data[field];
                return /^\(\d{3}\) \d{3}-\d{4}/.test(phone as string);
            case 'state':
                let state = <string>data[field];
                return !!StatesMap.find(s => s.value === state);
            default:
                let value = <unknown>data[field];
                if ( Array.isArray(value) ) {
                    return value.length > 0
                } else {
                    return value !== undefined && value !== null && value !== ''
                }
        }
    }

    function depsValid(...args: Array<keyof D>): boolean {
        return !args.find((dep) => {
            return !validateField(dep);
        });
    };


    return {
        validateField,
        depsValid
    };
}